import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="bg-card border border-border rounded-2xl p-10 max-w-md w-full text-center fade-up" data-testid="payment-cancel-page">
        <XCircle className="w-14 h-14 mx-auto text-muted-foreground mb-4" />
        <h1 className="font-heading text-2xl font-black">Checkout cancelled</h1>
        <p className="text-muted-foreground mt-1 mb-6">No worries — you can upgrade anytime.</p>
        <div className="flex gap-3">
          <Button onClick={() => navigate("/pricing")} className="rounded-full font-bold flex-1 h-11" data-testid="cancel-retry-btn">View plans</Button>
          <Button onClick={() => navigate("/")} variant="outline" className="rounded-full font-bold flex-1 h-11" data-testid="cancel-home-btn">Home</Button>
        </div>
      </div>
    </div>
  );
}
